<script setup lang="ts">
import StfCol from '@/ui/columns/StfCol.vue';
import StfSubHeading from '@/ui/typography/StfSubHeading.vue';
import StfInfoText from '@/ui/typography/StfInfoText.vue';
import useCountry from '@/composables/countryDependable';
interface Props {
    title: string;
    value?: number|undefined|null;
    heading?: boolean;
    subRow?: boolean;
}
withDefaults(defineProps<Props>(), {
    heading: false,
    subRow: false,
});

const country = useCountry();

</script>

<template>
    <StfCol col="9" :class="{'pl-4': subRow}">
        <template v-if="heading">
            <StfSubHeading>{{title}}</StfSubHeading>
        </template>
        <template v-else-if="subRow">
            {{title}}
        </template>
        <template v-else>
            <StfInfoText>{{title}}</StfInfoText>
        </template>
    </StfCol>
    <StfCol col="3" class="has-text-right">
        <template v-if="heading">
            <StfSubHeading>{{country.currencyWithCountry}}{{value}}</StfSubHeading>
        </template>
        <template v-else-if="subRow">
            {{country.currencyWithCountry}}{{value}}
        </template>
        <template v-else>
            <StfInfoText>{{country.currencyWithCountry}}{{value}}</StfInfoText>
        </template>
    </StfCol>
</template>

<style scoped lang="scss">

</style>